import {
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";
import React from "react";

const ManageWorkout = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    const workouts = [
        {
            id: 1,
            title: "Full Body Burn",
            thumbnail: "/static/images/workout1.webp",
            duration: "30 min",
            difficulty: "Intermediate",
            muscleGroup: "Full Body",
            equipment: "Dumbbells",
        },
        {
            id: 2,
            title: "Core Strength",
            thumbnail: "/static/images/workout1.webp",
            duration: "15 min",
            difficulty: "Beginner",
            muscleGroup: "Core",
            equipment: "None",
        },
    ];

    return (
        <>
            <div className="main_title">
                <h1>Manage Workouts</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Workouts
                </p>
            </div>

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search Workout"
                        />
                    </div>

                    <div className="right_s">
                        <Button className="btn btn_primary" onClick={() => navigate("add")}>
                            <AddIcon /> Add Workout
                        </Button>
                    </div>
                </div>

                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Thumbnail</TableCell>
                                <TableCell>Workout Title</TableCell>
                                <TableCell>Duration</TableCell>
                                <TableCell>Difficulty Level</TableCell>
                                <TableCell>Muscle Group</TableCell>
                                <TableCell>Equipment</TableCell>
                                <TableCell>Enable / Disable</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {workouts.map((item) => (
                                <TableRow hover key={item.id}>
                                    <TableCell>
                                        <figure className="thumb_small">
                                            <img
                                                src={item.thumbnail}
                                                alt={item.title}
                                                style={{ width: 55, height: 55, borderRadius: 8 }}
                                            />
                                        </figure>
                                    </TableCell>

                                    <TableCell>
                                        <b>{item.title}</b>
                                    </TableCell>

                                    <TableCell>{item.duration}</TableCell>

                                    <TableCell>{item.difficulty}</TableCell>

                                    <TableCell>{item.muscleGroup}</TableCell>

                                    <TableCell>{item.equipment}</TableCell>

                                    <TableCell>
                                        <SwitchToggle />
                                    </TableCell>

                                    <TableCell>
                                        <div className="table_actions v2">
                                            <IconButton
                                                onClick={() => navigate("view", { state: { workout: item } })}
                                            >
                                                <img src="/static/images/eye_icon.svg" alt="View" />
                                            </IconButton>

                                            <IconButton
                                                onClick={() => navigate("add", { state: { workout: item } })}
                                            >
                                                <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                            </IconButton>

                                            <IconButton>
                                                <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </>
    );
};

export default ManageWorkout;
